const serviceIntro = () => {
    new SplitText(".service-intro h3", {
        type: "lines",
        linesClass: "line line++"
    });
};

export default serviceIntro;